<div class="grid" style="padding-bottom: 30px">
  <div class="col-11 col-offset-1">
    <div class="flex align-items-center">
      <div class="flex-1 font-bold">
        {{ attribute.attributeName }}
      </div>
      <div class="flex ml-2 white-space-nowrap align-items-center" style="gap: 7px">
        @if(hasRoleMasterOperator()) {
          <p-selectbutton [allowEmpty]="false" [options]="shops" [(ngModel)]="selectedShop"  optionLabel="name" optionValue="value" (onChange)="shopChange()" />
        }@else {
          <p-toggleSwitch [(ngModel)]="checked" class="flex" (onChange)="switchChange($event)" />
          <b>{{ "editAttribute.autoriseEdit" | translate }}</b>
          <div class="flex gap-1 info-score">
            <img src="./assets/images/shop.svg" alt="shop" />
            <div>{{ operatorValue?.["source"] }}</div>
          </div>
        }
      </div>
    </div>
  </div>
  <div class="col-1 flex align-items-center">
    <p-radioButton
      inputId="operator"
      [(ngModel)]="selectedValue"
      [value]="(operatorValue?.['attributeCode'] === 'Typology'
      && operatorValue?.['source'].includes(selectedValue.source)
      && operatorValue?.['value']?.categoryBreadcrumbLoc === selectedValue?.value) ? selectedValue : operatorValue"
      (ngModelChange)="modelChange()"></p-radioButton>
  </div>
  <div class="col-11 mb-2">
    <div>
      @if (operatorValue != null) {
        @if (attribute.attributeType === "LONG_TEXT") {
          <textarea rows="5" pTextarea class="w-full" [(ngModel)]="operatorValue['value']"> </textarea>
        } @else if (attribute.attributeType === "LIST") {
          <p-select [options]="attribute.options" [(ngModel)]="operatorValue['value']" class="w-full" appendTo="body"></p-select>
        } @else if (attribute.attributeCode === "Typology") {
          <p-treeSelect
            class="w-full"
            appendTo="body"
            [showClear]="true"
            [options]="categories"
            placeholder="Select Item"
            [(ngModel)]="operatorValue['value']">
            <ng-template let-node pTemplate="default">
              <div>
                <span>{{ node?.categoryLabelLoc }}</span>
              </div>
            </ng-template>
            <ng-template let-node pTemplate="value">
              <div>
                @if (operatorValue["value"]) {
                  <span>{{ node?.categoryBreadcrumbLoc }}</span>
                } @else {
                  <span>
                    {{ "global.selectItem" | translate }}
                  </span>
                }
              </div>
            </ng-template>
          </p-treeSelect>
        } @else if(attribute.attributeType === "MEDIA" || attribute.attributeType === "PDF"){
            <p-fileUpload 
            name="media"
            customUpload="true"
            #fileUpload
            (onUpload)="onUpload($event)"
            (uploadHandler)="uploadFile($event)"
            (onSelect)="onFileSelect($event)"
            [multiple]="false"
            [accept]="attribute.attributeType === 'MEDIA' ? '.jpg, .jpeg, .png' : '.pdf'"
            maxFileSize="1000000"
            [chooseLabel]="'Choose' | translate"
            [uploadLabel]="'Upload' | translate"
            [cancelLabel]="'Cancel' | translate">
             <!-- <ng-template pTemplate="content">
              <ul *ngIf="uploadedFiles.length">
                <li *ngFor="let file of uploadedFiles">
                  {{ file.name }} - {{ file.size }} bytes
                </li>
              </ul>
            </ng-template> -->
          </p-fileUpload>
          @if(attribute.attributeCode != 'IMAGE|1505-1') {
            <button
            pButton
            type="button"
            [label]="attribute.attributeType === 'PDF'?  ('buttons.deleteFile'| translate) : ('buttons.deleteMedia' | translate)"
            icon="pi pi-trash"
            (click)="deleteMedia()"
            [disabled]="showSpinner"
            severity="danger"
            class="mr-2 mt-3"></button>
          }
        } @else {
          <input type="text" pInputText class="w-full block flex-grow-1" [(ngModel)]="operatorValue['value']" />
        }
      } @else {
        <p-skeleton width="100%" height="4rem" />
      }
    </div>
  </div>

  @for (value of values; track $index) {
    <div class="col-11 col-offset-1">
      <div class="flex">
        <div class="flex-1 font-bold">{{ attribute.attributeName }}</div>
        <div class="flex ml-2 white-space-nowrap" style="gap: 7px">
          <div class="flex gap-1 info-score">
            <img src="./assets/images/shop.svg" alt="shop" />
            <div>{{ value["source"] }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-1 flex align-items-center">
      <p-radioButton [(ngModel)]="selectedValue" [value]="value" (ngModelChange)="modelChange()"></p-radioButton>
    </div>
    <div class="col-11 mb-2">
      <div>
        @if (attribute.attributeType === "LONG_TEXT") {
          <textarea rows="5" pTextarea class="w-full" [disabled]="true" [value]="value['value']"> </textarea>
        } @else if(attribute.attributeType === "MEDIA"){
          <div class="flex-row" style="flex-flow: row wrap;">
            <p-image
              [src]="value['value'] || './assets/images/fallback.png'"
              height="100px" />
          </div>
        
        }@else if(attribute.attributeType === "PDF") {
          <a class="document-link" target="_blank" [href]="value['value']"><i class="pi pi-file-pdf mr-2"></i>
            PDF {{attribute.attributeName}}
          </a>
        }@else {
          <input type="text" pInputText class="w-full block flex-grow-1" [disabled]="true" [value]="value['value']" />
        }
      </div>
    </div>
  }
</div>
@if(showErrorMandatoryAttributes) {
  <div class="mt-5 mb-3">
    <i class="pi pi-info-circle bg-icon" style="color: red;"></i>
    <span class="pl-2" style="font-size: 1rem; color: red">{{'alerts.errorMandatoryAttributes' | translate}}</span>
  </div>
}

  <div class="footer-buttons">
    <div class="flex">
      <div class="flex-1">
        <button
          pButton
          type="button"
          label="{{ 'buttons.cancel' | translate }}"
          [outlined]="true"
          icon="pi pi-times-circle"
          class="mr-2"
          (click)="closeDialog()"></button>
      </div>
      @if (buttonOutlined) {
        <button
          pButton
          type="button"
          label="{{ 'buttons.validate' | translate }}"
          [outlined]="buttonOutlined"
          (click)="updateAttribute()"
          icon="pi pi-check-circle"
          [disabled]="!selectedValue || showSpinner"
          class="mr-2"></button>
      } @else {
        <button
          pButton
          type="button"
          label="{{ 'buttons.validate' | translate }}"
          icon="pi pi-check-circle"
          (click)="updateAttribute()"
          [disabled]="!selectedValue || showSpinner"
          class="mr-2"></button>
      }
    </div>
  </div>


@if(showSpinner) {
  <div class="flex justify-content-center">
    <p-progressSpinner 
        styleClass="w-4rem h-4rem" 
        strokeWidth="8" 
        animationDuration=".5s" />
</div>
}
<p-toast></p-toast>
